const listeners = new Set<() => void>();
export function notifyProblemReviewChange() { listeners.forEach((listener) => listener()); }
export function subscribeProblemReviewChanges(listener: () => void) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

/** 한 번의 복귀 이벤트 묶음을 합치고, 조회 중 변경은 후속 조회 한 번으로 처리한다. */
export function createReviewReloadQueue(reload: () => Promise<unknown>) {
  let timer: ReturnType<typeof setTimeout> | undefined;
  let running = false;
  let pending = false;
  let disposed = false;
  const request = () => {
    if (disposed) return;
    pending = true;
    if (timer !== undefined || running) return;
    timer = setTimeout(async () => {
      timer = undefined;
      pending = false;
      running = true;
      try {
        await reload();
      } finally {
        running = false;
        if (pending && !disposed) request();
      }
    }, 100);
  };
  return {
    request,
    dispose() {
      disposed = true;
      if (timer !== undefined) clearTimeout(timer);
    },
  };
}
